import { Button } from '@/shared/ui/button';
import { motion } from 'motion/react';
import { useNavigate } from 'react-router-dom';

const LastSection = () => {

  const navigate = useNavigate()

  return (
    <div className="min-h-[60vh] md:min-h-[70vh] w-full flex flex-col relative items-center pt-16 md:pt-24 overflow-hidden">
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="pb-3 font-bold text-5xl lg:text-7xl font-montserrat text-center bg-gradient-to-b from-[#6519CF] to-[#320177] inline-block text-transparent bg-clip-text">
        The world moves at the <br /> speed of culture.
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
        className="md:text-lg px-2 md:px-10 text-center font-poppins font-light py-8 text-[#2A0163] max-w-xl relative z-50">
        That’s what siAi enables - a living system that keeps your voice sharp, your story alive, and your brand unmistakably human in an AI-driven world.
        <span className="font-semibold">Your voice deserves more than automation. It deserves evolution.</span>
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.8, ease: "easeOut" }}
        className="relative flex items-center gap-2 justify-center w-full z-20">
        <Button className="bg-gradient-to-b from-[#320177] to-[#5D02DD] rounded-full font-poppins px-8 py-6" onClick={() => navigate('/contact')}>Join siAi</Button>
      </motion.div>
    </div>
  )
}

export default LastSection;
